export const Layout = () => import('@/layout/index.vue')
import { getRouteRoles } from '@/utils/index'

/**
 * 业务管理路由
 */

// 合同模版管理
const templateListRoute = {
  path: 'template/list',
  name: 'BusinessTemplateList',
  component: () => import('@/views/business/template/list.vue'),
  meta: {
    icon: 'Document',
    title: '合同模版管理',
    roles: ['admin/business.Template/list'],
    activeMenuTop: '/business',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  }
}

const templateInfoRoute = {
  path: 'template/info/:id',
  name: 'BusinessTemplateInfo',
  component: () => import('@/views/business/template/info.vue'),
  meta: {
    title: '合同模版信息',
    roles: ['admin/business.Template/list'],
    activeMenu: '/business/template/list',
    activeMenuTop: '/business',
    hidden: true,
    keepAlive: true,
    alwaysShow: false
  }
}

const templateAddRoute = {
  path: 'template/add',
  name: 'BusinessTemplateAdd',
  component: () => import('@/views/business/template/add.vue'),
  meta: {
    title: '合同模版添加',
    roles: ['admin/business.Template/list'],
    activeMenu: '/business/template/list',
    activeMenuTop: '/business',
    hidden: true,
    keepAlive: true,
    alwaysShow: false
  }
}

const templateEditRoute = {
  path: 'template/edit/:id',
  name: 'BusinessTemplateEdit',
  component: () => import('@/views/business/template/edit.vue'),
  meta: {
    title: '合同模版修改',
    roles: ['admin/business.Template/list'],
    activeMenu: '/business/template/list',
    activeMenuTop: '/business',
    hidden: true,
    keepAlive: true,
    alwaysShow: false
  }
}

// 分类管理
const categoryListRoute = {
  path: 'category/list',
  name: 'BusinessCategoryList',
  component: () => import('@/views/business/category/list.vue'),
  meta: {
    icon: 'Folder',
    title: '分类管理',
    roles: ['admin/contract.ContractCategory/list'],
    activeMenuTop: '/business',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  }
}

// 产品管理
const productListRoute = {
  path: 'product/list',
  name: 'BusinessProductList',
  component: () => import('@/views/business/product/list.vue'),
  meta: {
    icon: 'Box',
    title: '产品管理',
    roles: ['admin/business.Product/list'],
    activeMenuTop: '/business',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  }
}

// 套餐管理
const packageListRoute = {
  path: 'package/list',
  name: 'BusinessPackageList',
  component: () => import('@/views/business/package/list.vue'),
  meta: {
    icon: 'ShoppingBag',
    title: '套餐管理',
    roles: ['admin/business.Package/list'],
    activeMenuTop: '/business',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  }
}

// 订单管理
const orderListRoute = {
  path: 'order/list',
  name: 'BusinessOrderList',
  component: () => import('@/views/business/order/list.vue'),
  meta: {
    icon: 'ShoppingCart',
    title: '订单管理',
    roles: ['admin/business.Order/list'],
    activeMenuTop: '/business',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  }
}

// 发票申请列表
const invoiceListRoute = {
  path: 'invoice/list',
  name: 'BusinessInvoiceList',
  component: () => import('@/views/business/invoice/list.vue'),
  meta: {
    icon: 'Document',
    title: '发票申请管理',
    roles: ['admin/order.Invoice/list'],
    activeMenuTop: '/business',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  }
}

// 体验用户管理
const experienceListRoute = {
  path: 'experience/list',
  name: 'BusinessExperienceList',
  component: () => import('@/views/business/experience/list.vue'),
  meta: {
    icon: 'User',
    title: '体验用户管理',
    roles: ['admin/member.Member/experienceBatchList'],
    activeMenuTop: '/business',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  }
}

// 代理商管理
const agentListRoute = {
  path: 'agent/list',
  name: 'BusinessAgentList',
  component: () => import('@/views/business/agent/list.vue'),
  meta: {
    icon: 'UserFilled',
    title: '代理商管理',
    roles: ['admin/order.Agent/list'],
    activeMenuTop: '/business',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  }
}

const agentInfoRoute = {
  path: 'agent/info/:id',
  name: 'BusinessAgentInfo',
  component: () => import('@/views/business/agent/info.vue'),
  meta: {
    title: '代理商信息',
    roles: ['admin/order.Agent/list'],
    activeMenu: '/business/agent/list',
    activeMenuTop: '/business',
    hidden: true,
    keepAlive: true,
    alwaysShow: false
  }
}

const agentAddRoute = {
  path: 'agent/add',
  name: 'BusinessAgentAdd',
  component: () => import('@/views/business/agent/add.vue'),
  meta: {
    title: '代理商添加',
    roles: ['admin/order.Agent/list'],
    activeMenu: '/business/agent/list',
    activeMenuTop: '/business',
    hidden: true,
    keepAlive: true,
    alwaysShow: false
  }
}

const agentEditRoute = {
  path: 'agent/edit/:id',
  name: 'BusinessAgentEdit',
  component: () => import('@/views/business/agent/edit.vue'),
  meta: {
    title: '代理商修改',
    roles: ['admin/order.Agent/list'],
    activeMenu: '/business/agent/list',
    activeMenuTop: '/business',
    hidden: true,
    keepAlive: true,
    alwaysShow: false
  }
}

// 产品兑换码管理
const keyListRoute = {
  path: 'key/list',
  name: 'BusinessKeyList',
  component: () => import('@/views/business/key/list.vue'),
  meta: {
    icon: 'Key',
    title: '产品兑换码管理',
    roles: ['admin/business.Key/list'],
    activeMenuTop: '/business',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  }
}

// 人工复核列表
const reviewListRoute = {
  path: 'review/list',
  name: 'BusinessReviewList',
  component: () => import('@/views/business/review/list.vue'),
  meta: {
    icon: 'DocumentChecked',
    title: '人工复核列表',
    roles: ['admin/business.Review/list'],
    activeMenuTop: '/business',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  }
}

// 电签管理
const esignListRoute = {
  path: 'esign/list',
  name: 'BusinessEsignList',
  component: () => import('@/views/business/esign/list.vue'),
  meta: {
    icon: 'EditPen',
    title: '电签管理',
    roles: ['admin/contract.Esign/list'],
    activeMenuTop: '/business',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  }
}

// 电签申请详情
const esignInfoRoute = {
  path: 'esign/info/:id',
  name: 'BusinessEsignInfo',
  component: () => import('@/views/business/esign/info.vue'),
  meta: {
    title: '电签申请详情',
    roles: ['admin/contract.Esign/list'],
    activeMenu: '/business/esign/list',
    activeMenuTop: '/business',
    hidden: true,
    keepAlive: true,
    alwaysShow: false
  }
}

// 人工复核详情
const reviewInfoRoute = {
  path: 'review/info/:id',
  name: 'BusinessReviewInfo',
  component: () => import('@/views/business/review/info.vue'),
  meta: {
    title: '复核详情',
    roles: ['admin/business.Review/list'],
    activeMenu: '/business/review/list',
    activeMenuTop: '/business',
    hidden: true,
    keepAlive: true,
    alwaysShow: false
  }
}

// 人工复核律师管理
const reviewLawyerListRoute = {
  path: 'review-lawyer/list',
  name: 'BusinessReviewLawyerList',
  component: () => import('@/views/business/review-lawyer/list.vue'),
  meta: {
    icon: 'UserFilled',
    title: '人工复核律师',
    roles: ['admin/business.Review/list'],
    activeMenuTop: '/business',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  }
}

const reviewLawyerInfoRoute = {
  path: 'review-lawyer/info/:id',
  name: 'BusinessReviewLawyerInfo',
  component: () => import('@/views/business/review-lawyer/info.vue'),
  meta: {
    title: '律师详情',
    hideParamInTag: true,
    roles: ['admin/business.Review/list'],
    activeMenu: '/business/review-lawyer/list',
    activeMenuTop: '/business',
    hidden: true,
    keepAlive: true,
    alwaysShow: false
  }
}

// 律师接单工作台
const reviewClaimsRoute = {
  path: 'review-claims/list',
  name: 'BusinessReviewClaims',
  component: () => import('@/views/business/review-claims/list.vue'),
  meta: {
    icon: 'Finished',
    title: '我的接单',
    roles: ['admin/business.Review/list'],
    activeMenuTop: '/business',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  }
}

// 操作记录监控
const logListRoute = {
  path: 'log/list',
  name: 'BusinessLogList',
  component: () => import('@/views/business/log/list.vue'),
  meta: {
    icon: 'Document',
    title: '操作记录监控',
    roles: ['admin/business.Log/list'],
    activeMenuTop: '/business',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  }
}
const feedbackRoute = {
  path: 'feedback',
  name: 'SettingFeedback',
  redirect: 'noRedirect',
  meta: {
    icon: 'ChatLineRound',
    title: '意见反馈管理',
    roles: ['admin/setting.Feedback/list'],
    activeMenuTop: '/setting',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  },
  children: [
    {
      path: 'list',
      name: 'SettingFeedbackList',
      component: () => import('@/views/setting/feedback/list.vue'),
      meta: {
        title: '意见反馈管理',
        roles: ['admin/setting.Feedback/list'],
        activeMenuTop: '/setting',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      }
    },
    {
      path: 'info/:id',
      name: 'SettingFeedbackInfo',
      component: () => import('@/views/setting/feedback/info.vue'),
      meta: {
        title: '反馈信息',
        roles: ['admin/setting.Feedback/list'],
        activeMenu: '/setting/feedback/list',
        activeMenuTop: '/setting',
        hidden: true,
        keepAlive: true,
        alwaysShow: false
      }
    },
    {
      path: 'add',
      name: 'SettingFeedbackAdd',
      component: () => import('@/views/setting/feedback/add.vue'),
      meta: {
        title: '反馈添加',
        roles: ['admin/setting.Feedback/list'],
        activeMenu: '/setting/feedback/list',
        activeMenuTop: '/setting',
        hidden: true,
        keepAlive: true,
        alwaysShow: false
      }
    },
    {
      path: 'edit/:id',
      name: 'SettingFeedbackEdit',
      component: () => import('@/views/setting/feedback/edit.vue'),
      meta: {
        title: '反馈修改',
        roles: ['admin/setting.Feedback/list'],
        activeMenu: '/setting/feedback/list',
        activeMenuTop: '/setting',
        hidden: true,
        keepAlive: true,
        alwaysShow: false
      }
    }
  ]
}

// 操作记录详情
const logInfoRoute = {
  path: 'log/info/:id',
  name: 'BusinessLogInfo',
  component: () => import('@/views/business/log/info.vue'),
  meta: {
    title: '操作记录详情',
    roles: ['admin/business.Log/list'],
    activeMenu: '/business/log/list',
    activeMenuTop: '/business',
    hidden: true,
    keepAlive: true,
    alwaysShow: false
  }
}

// 用户管理
const memberListRoute = {
  path: 'member/list',
  name: 'BusinessMemberList',
  component: () => import('@/views/member/member/list.vue'),
  meta: {
    icon: 'User',
    title: '用户管理',
    roles: ['admin/member.Member/list'],
    activeMenuTop: '/business',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  }
}

const memberInfoRoute = {
  path: 'member/info/:id',
  name: 'BusinessMemberInfo',
  component: () => import('@/views/member/member/info.vue'),
  meta: {
    title: '用户信息',
    roles: ['admin/member.Member/list'],
    activeMenu: '/business/member/list',
    activeMenuTop: '/business',
    hidden: true,
    keepAlive: true,
    alwaysShow: false
  }
}

const memberAddRoute = {
  path: 'member/add',
  name: 'BusinessMemberAdd',
  component: () => import('@/views/member/member/add.vue'),
  meta: {
    title: '用户添加',
    roles: ['admin/member.Member/list'],
    activeMenu: '/business/member/list',
    activeMenuTop: '/business',
    hidden: true,
    keepAlive: true,
    alwaysShow: false
  }
}

const memberEditRoute = {
  path: 'member/edit/:id',
  name: 'BusinessMemberEdit',
  component: () => import('@/views/member/member/edit.vue'),
  meta: {
    title: '用户修改',
    roles: ['admin/member.Member/list'],
    activeMenu: '/business/member/list',
    activeMenuTop: '/business',
    hidden: true,
    keepAlive: true,
    alwaysShow: false
  }
}

// 履行提醒发送记录
const fulfillmentReminderLogListRoute = {
  path: 'fulfillment-reminder-log/list',
  name: 'BusinessFulfillmentReminderLogList',
  component: () => import('@/views/business/fulfillment-reminder-log/list.vue'),
  meta: {
    icon: 'Message',
    title: '履行提醒发送记录',
    roles: ['admin/business.FulfillmentReminderLog/list'],
    activeMenuTop: '/business',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  }
}

// 用户使用tokens记录
const userTokenLogListRoute = {
  path: 'user-token-log/list',
  name: 'BusinessUserTokenLogList',
  component: () => import('@/views/business/user-token-log/list.vue'),
  meta: {
    icon: 'Document',
    title: '用户使用tokens记录',
    roles: ['admin/business.UserTokenLog/list'],
    activeMenuTop: '/business',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  }
}

// 产品兑换记录
const redeemLogListRoute = {
  path: 'redeem-log/list',
  name: 'BusinessRedeemLogList',
  component: () => import('@/views/business/redeem-log/list.vue'),
  meta: {
    icon: 'Ticket',
    title: '产品兑换记录',
    roles: ['admin/system.RedeemCode/redeemList'],
    activeMenuTop: '/business',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  }
}

// 君子签管理后台
const junziqianAdminRoute = {
  path: 'junziqian-admin/list',
  name: 'BusinessJunziqianAdminList',
  component: () => import('@/views/business/junziqian-admin/index.vue'),
  meta: {
    icon: 'Link',
    title: '君子签管理后台',
    roles: ['admin/business.JunziqianAdmin/index'],
    activeMenuTop: '/business',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  }
}

// 小程序微信客户
const memberThirdListRoute = {
  path: 'member-third/list',
  name: 'BusinessMemberThirdList',
  component: () => import('@/views/member/third/list.vue'),
  meta: {
    icon: 'User',
    title: '小程序微信客户',
    roles: ['admin/member.Third/list'],
    activeMenuTop: '/business',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  }
}

const memberThirdInfoRoute = {
  path: 'member-third/info/:id',
  name: 'BusinessMemberThirdInfo',
  component: () => import('@/views/member/third/info.vue'),
  meta: {
    title: '小程序微信客户信息',
    roles: ['admin/member.Third/list'],
    activeMenu: '/business/member-third/list',
    activeMenuTop: '/business',
    hidden: true,
    keepAlive: true,
    alwaysShow: false
  }
}

const memberThirdAddRoute = {
  path: 'member-third/add',
  name: 'BusinessMemberThirdAdd',
  component: () => import('@/views/member/third/add.vue'),
  meta: {
    title: '小程序微信客户添加',
    roles: ['admin/member.Third/list'],
    activeMenu: '/business/member-third/list',
    activeMenuTop: '/business',
    hidden: true,
    keepAlive: true,
    alwaysShow: false
  }
}

const memberThirdEditRoute = {
  path: 'member-third/edit/:id',
  name: 'BusinessMemberThirdEdit',
  component: () => import('@/views/member/third/edit.vue'),
  meta: {
    title: '小程序微信客户修改',
    roles: ['admin/member.Third/list'],
    activeMenu: '/business/member-third/list',
    activeMenuTop: '/business',
    hidden: true,
    keepAlive: true,
    alwaysShow: false
  }
}

// 业务管理父路由
const businessRoute = {
  path: '/business',
  redirect: 'noRedirect',
  component: Layout,
  meta: {
    icon: 'Briefcase',
    title: '业务管理',
    roles: [],
    activeMenuTop: '/business',
    hidden: false,
    keepAlive: true,
    alwaysShow: true
  },
  children: [
    templateListRoute,
    templateInfoRoute,
    templateAddRoute,
    feedbackRoute,
    templateEditRoute,
    categoryListRoute,
    productListRoute,
    packageListRoute,
    orderListRoute,
    invoiceListRoute,
    experienceListRoute,
    agentListRoute,
    agentInfoRoute,
    agentAddRoute,
    agentEditRoute,
    keyListRoute,
    reviewListRoute,
    reviewInfoRoute,
    reviewLawyerListRoute,
    reviewLawyerInfoRoute,
    reviewClaimsRoute,
    esignListRoute,
    esignInfoRoute,
    logListRoute,
    logInfoRoute,
    memberListRoute,
    memberInfoRoute,
    memberAddRoute,
    memberEditRoute,
    fulfillmentReminderLogListRoute,
    userTokenLogListRoute,
    redeemLogListRoute,
    junziqianAdminRoute,
    memberThirdListRoute,
    memberThirdInfoRoute,
    memberThirdAddRoute,
    memberThirdEditRoute
  ]
}

// 为每个子路由设置 roles
businessRoute.children.forEach((route) => {
  if (!route.meta.roles || route.meta.roles.length === 0) {
    route.meta.roles = getRouteRoles(route)
  }
})

// 设置父路由的 roles（合并所有子路由的 roles）
const allRoles = new Set()
businessRoute.children.forEach((route) => {
  if (route.meta.roles && Array.isArray(route.meta.roles)) {
    route.meta.roles.forEach((role) => allRoles.add(role))
  }
})
businessRoute.meta.roles = Array.from(allRoles)

export default businessRoute
